import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import CardSection from '@shared/components/CardSection';
import type { SystemResource } from '../types';

interface Props {
  resources: SystemResource[];
}

function resourceColor(percent: number): 'success' | 'warning' | 'error' {
  if (percent >= 90) return 'error';
  if (percent >= 70) return 'warning';
  return 'success';
}

export default function SystemResources({ resources }: Props) {
  return (
    <CardSection>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        System Resources
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {resources.map((r) => (
          <Box key={r.label}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="body2">{r.label}</Typography>
              <Typography variant="body2" color="text.secondary">
                {r.used} / {r.total}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={r.usedPercent}
              color={resourceColor(r.usedPercent)}
              sx={{ height: 6, borderRadius: 1 }}
            />
          </Box>
        ))}
      </Box>
    </CardSection>
  );
}
